
    import dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';
    import QuestionMixin from '@/components/JobView/Apply/Questions/QuestionMixin';

    dayjs.extend(utc);

    export default {
        name: 'QuestionDate',

        components: {
            Datepicker: () => process.client ? import('vuejs-datepicker') : {},
        },

        mixins: [
            QuestionMixin,
        ],

        data() {
            return {
                answer: '',
                questionId: `question_date_${this.question.id}`,
            };
        },

        created() {
            this.getStringAnswer();
        },

        methods: {
            dateFormatter(date) {
                return dayjs.utc(date).local().format('DD MMMM YYYY');
            },
        },
    };
